import { Component } from '@angular/core';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss']
})
export class ExploreComponent {
  activeFilter = 'All';

  filters = ['All', 'Music', 'Podcasts', 'Following'];

  jumpBackIn = [
    { title: 'Fantan Mojah', imageUrl: '../assets/img/albums/7.jpg', type: 'artist' },
    { title: 'Mr. Morale & The...', artist: 'Kendrick Lamar', imageUrl: '../assets/img/albums/1.jpg', type: 'album' },
    { title: 'Anderson Paak', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/7.jpg' },
    { title: 'Kings of Leon', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/7.jpg' },
    { title: 'Gorillaz', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
  ];

  bestOfArtists = [
    { title: 'Anderson Paak', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Kings of Leon', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Gorillaz', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Anderson Paak', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Kings of Leon', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
    { title: 'Gorillaz', description: 'The essential tracks, all in one.', imageUrl: '../assets/img/albums/1.jpg' },
  ];

  recents = {
    title: 'White Knuckle Ride',
    artist: 'Jamiroquai',
    device: 'Echo Dot-2GB',
    playing: true
  };

  selectFilter(filter: string) {
    this.activeFilter = filter;
  }

  togglePlay() {
    this.recents.playing = !this.recents.playing;
  }
}
